<template>
  <svg width="21" height="21" viewBox="0 0 21 21" fill="none">
    <g clip-path="url(#clip0_322_302)">
      <path
        d="M20 10.5C20 5.25329 15.7467 1 10.5 1C5.25329 1 1 5.25329 1 10.5C1 15.7467 5.25329 20 10.5 20C15.7467 20 20 15.7467 20 10.5ZM21 10.5C21 16.299 16.299 21 10.5 21C4.70101 21 0 16.299 0 10.5C0 4.70101 4.70101 0 10.5 0C16.299 0 21 4.70101 21 10.5Z"
        :fill="color"
      />
      <path
        d="M10.5093 9.79289L15.1461 5.1468C15.3412 4.95134 15.6577 4.95103 15.8532 5.14609C16.0487 5.34116 16.049 5.65774 15.8539 5.8532L10.8639 10.8532C10.6688 11.0487 10.3522 11.049 10.1568 10.8539L5.1468 5.85391C4.95134 5.65884 4.95103 5.34226 5.14609 5.1468C5.34116 4.95134 5.65774 4.95103 5.8532 5.14609L10.5093 9.79289Z"
        :fill="color"
      />
      <path
        d="M10.4907 11.2071L5.85391 15.8532C5.65884 16.0487 5.34226 16.049 5.1468 15.8539C4.95134 15.6588 4.95103 15.3423 5.14609 15.1468L10.1361 10.1468C10.3312 9.95134 10.6478 9.95103 10.8432 10.1461L15.8532 15.1461C16.0487 15.3412 16.049 15.6577 15.8539 15.8532C15.6588 16.0487 15.3423 16.049 15.1468 15.8539L10.4907 11.2071Z"
        :fill="color"
      />
    </g>
    <defs>
      <clipPath id="clip0_322_302">
        <rect width="21" height="21" fill="white" />
      </clipPath>
    </defs>
  </svg>
</template>

<script>
  export default {
    name: 'IconRemoveAAG',
    props: {
      color: {
        type: String,
        default: '#585B60',
      },
    }
  };
</script>

<style lang="scss" scoped></style>
